<template>
  <v-card
    flat
    max-width="700"
    :style="{
      borderBottom: '3px solid #272727',
      borderLeft: '1px solid #272727',
      borderTop: '1px solid #272727',
      borderRight: '3px solid #272727',
    }"
  >
    <div>
      <v-sheet
        class="d-flex justify-center align-center py-2"
        color="smokeDark"
        style="
          font-size: 10pt;
          font-weight: 600;
          border-top-right-radius: 7px;
          border-top-left-radius: 7px;
        "
      >
        Media
      </v-sheet>
      <v-divider class="primary"></v-divider>
    </div>
    <v-data-table
      :headers="headers"
      :items="filtered"
      :items-per-page="5"
      hide-default-header
      @click:row="selectMedia"
      style="cursor: pointer"
      :search="search_media"
      :loading="media_loading"
      calculate-widths
    >
      <template v-slot:[`item.url`]="{ item }">
        <v-hover>
          <template v-slot:default="{ isHovering, props }">
            <div style="width: 140px" v-bind="props">
              <div v-if="item.extension === 'pdf'" style="position: relative">
                <embed
                  :src="item.src"
                  type="application/pdf"
                  width="100%"
                  height="100px"
                />
              </div>
              <v-img
                v-else
                :src="item.thumbnail ? item.thumbnail : item.src"
                height="100"
                width="140"
                cover
              >
                <div
                  @click.stop="preview(item.src)"
                  v-if="isHovering"
                  class="d-flex align-center justify-center transition-fast-in-fast-out"
                  style="height: 100%"
                >
                  <v-btn class="smoke" icon size="small"
                    ><v-icon color="primary" size="small"
                      >mdi-open-in-new</v-icon
                    ></v-btn
                  >
                </div>
              </v-img>
            </div>
          </template>
        </v-hover>
      </template>

      <template v-slot:[`item.title`]="{ item }">
        <div style="max-width: 400px">
          <p
            class="mb-1"
            style="
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            <span v-if="item.type === 'video'"
              ><v-icon class="mr-2 mb-1" size="small"
                >mdi-movie-open</v-icon
              ></span
            >{{ item.title }}
          </p>
          <p
            class="mb-0"
            style="font-size: 10px; font-weight: 600; opacity: 0.4"
          >
            {{ Number.parseFloat(item.size / 1024).toFixed(1) }}MB &#183;
            {{ item.extension.toUpperCase() }} &#183;
            {{ item.created_by_email.toUpperCase() }} &#183;
            {{ formatDate(item.created_at) }}
          </p>
          <div class="d-flex flex-wrap mt-1" style="gap: 5px">
            <v-chip
              color="info"
              size="x-small"
              v-for="(c, index) in item.tags"
              :key="index"
              >{{ c }}</v-chip
            >
          </div>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-menu transition="slide-y-transition" bottom>
          <template v-slot:activator="{ props }">
            <v-btn variant="text" v-bind="props" icon>
              <v-icon size="small">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link class="px-4" @click="preview(item.src)">
              <v-icon size="small" class="mr-3">mdi-open-in-new</v-icon>
              View
            </v-list-item>
            <v-list-item
              link
              class="px-4"
              @click="$store.dispatch('deleteMedia', item.uid)"
            >
              <v-icon size="small" class="mr-3">mdi-delete</v-icon>
              Delete
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
import { db } from "@/firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { getStorage, ref, deleteObject } from "firebase/storage";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { DateTime } from "luxon";

export default {
  props: ["drawer", "tag", "search"],
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      media: (state) => state.media.media,
      media_loading: (state) => state.loading.media,
    }),
    filtered() {
      let list = this.media;
      if (this.search) {
        list = list.filter((i) =>
          i.title.toLowerCase().includes(this.search.toLowerCase())
        );
      }

      return list;
    },
  },
  data() {
    return {
      headers: [
        { text: "Image", value: "url", align: "start" },
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },

        { text: "Actions", value: "actions", align: "end" },
      ],
      items: [],
      loading: false,
      next_page: "",
      search_media: "",
      tab: 0,
    };
  },
  methods: {
    deleteItem(i) {
      if (i.posts.length > 0) {
        this.$store.commit("setNotification", {
          show: true,
          text: "This file is still used in some posts. Please remove (the images from) these posts first.",
          type: "error",
          icon: "",
          multiline: true,
        });
      } else {
        console.log(i);
        const storage = getStorage();

        const storageRef = ref(
          storage,
          `${i.workspace}/${i.uid}.${i.extension}`
        );

        deleteObject(storageRef)
          .then(async () => {
            await deleteDoc(doc(db, "workspaces", i.workspace, "media", i.uid));
            this.$store.dispatch("fetchMedia");
          })
          .then(() => {
            this.$store.commit("setNotification", {
              show: true,
              text: "File deleted!",
              type: "primary",
              icon: "",
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    change(v) {
      if (!v) {
        this.$emit("close");
      }
    },
    preview(url) {
      window.open(url, "_blank");
    },
    async searchMedia() {
      this.loading = true;
      this.tab = 1;
      const get = httpsCallable(functions, "pexelsGet");
      const res = await get({ query: this.search });
      this.items = [];
      this.items = res.data.photos;
      this.next_page = res.data.next_page;
      this.nextPage();
      this.loading = false;
    },
    async nextPage() {
      const get = httpsCallable(functions, "pexelsGetNext");
      const res = await get({ url: this.next_page });

      res.data.photos.forEach((p) => {
        this.items.push(p);
      });
      this.next_page = res.data.next_page;
    },
    formatDate(d) {
      let time = DateTime.fromSeconds(d);
      return time.toFormat("ff");
    },
    async onFileChange() {
      var files = this.$refs.headerRef.files;
      const uploads = [...files];

      for (let x in uploads) {
        this.uploadFiles(uploads[x]);
      }
    },
    setPreviewSize(size) {
      this.$store.dispatch("setPreviewSize", size);
    },
    selectMedia(i) {
      if (this.$route.path.includes("/media")) {
        return;
      } else {
        this.$emit("media", {
          url: i.uid ? i.url : i.src.large,
          type: "stock",
          uid: i.uid ? i.uid : "",
          title: i.uid ? i.title : "",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
